export const ageOptions = [
  {
    label: '0-17',
    value: '0-17',
  },
  {
    label: '18-24',
    value: '18-24',
  },
  {
    label: '25-34',
    value: '25-34',
  },
  {
    label: '35-44',
    value: '35-44',
  },
  {
    label: '45-54',
    value: '45-54',
  },
  {
    label: '55-64',
    value: '55-64',
  },
  {
    label: '65 und älter',
    value: '65+',
  },
];

export const genderOptions = [
  {
    label: 'Männlich',
    value: 'male',
    selected: false,
  },
  {
    label: 'Weiblich',
    value: 'female',
    selected: false,
  },
];

export const incomeOptions = [
  {
    label: 'Tief',
    value: 'low',
    selected: false,
  },
  {
    label: 'Mittel',
    value: 'medium',
    selected: false,
  },
  {
    label: 'Hoch',
    value: 'high',
    selected: false,
  },
];

export const languageOptions = [
  {
    label: 'Deutsch',
    value: 'de',
  },
  {
    label: 'Französisch',
    value: 'fr',
  },
  {
    label: 'Englisch',
    value: 'en',
  },
  {
    label: 'Italienisch',
    value: 'it',
  },
];

export const locationOptions = [
  {
    label: 'Kanton FR',
    value: 'Kanton FR',
  },
  {
    label: 'Kanton BE',
    value: 'Kanton BE',
  },
  {
    label: 'Kanton VD',
    value: 'Kanton VD',
  },
  {
    label: 'Zürich',
    value: 'Zürich',
  },
];

interface Option {
  label: string;
  value: string;
}

export const industryOptions: Option[] = [
  { label: 'Bildung und Erziehung', value: 'bildung' },
  { label: 'Dienstleistungen', value: 'dienstleistungen' },
  { label: 'Gesundheit', value: 'gesundheit' },
  { label: 'Handel', value: 'handel' },
  { label: 'Industrie', value: 'industrie' },
  { label: 'IT & Kommunikation', value: 'it' },
  { label: 'Tourismus', value: 'tourismus' },
  { label: 'Transport & Logistik', value: 'logistik' },
  { label: 'Finanzen', value: 'finanzen' },
  { label: 'Öffentlicher Sektor', value: 'oeffentlich' },
];

export const companySizeOptions: Option[] = [
  { value: '1-9', label: 'bis 9' },
  { value: '10-49', label: '10-49' },
  { value: '50-249', label: '50-249' },
  { value: '250+', label: '250+' },
];
